import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { Share as ShareIcon } from '@material-ui/icons';
import React from 'react';
import { useDocumentData, useLocalization } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {
      display: 'inline-block'
    },
    icon: {}
  });
});

/**
 * Own properties for the Share component
 */

/**
 * Component that allows sharing
 */
export const Share = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const {
    documentData
  } = useDocumentData();
  return /*#__PURE__*/React.createElement(IconButton, {
    className: classes.iconButton,
    color: "inherit",
    title: localization.share,
    onClick: () => props.share(documentData),
    id: "Share"
  }, /*#__PURE__*/React.createElement(ShareIcon, {
    className: classes.icon
  }));
};
//# sourceMappingURL=share-widget.js.map